module.exports = __webpack_public_path__ + "cv.svg?383ab6208681e8dfd9721c0ab602cd72";